import React from 'react';
import { useHistory } from 'react-router-dom';

import { adminApi } from './adminApi';
import { DataTable, EmptyState, PageHeader, SearchInput } from './kit';
import Pagination from './Pagination';
import useListState from './useListState';
import { formatDay, formatDocument, formatPhoneBR, useSlashToSearch } from './ui';

const integer = new Intl.NumberFormat('pt-BR');

const COLUMNS = [
  { key: 'name', label: 'Nome', sortKeys: ['name', 'name'], render: (user) => <strong className='ax-strong'>{user.name || 'Sem nome'}</strong> },
  { key: 'email', label: 'E-mail', render: (user) => user.email || '—' },
  { key: 'phone', label: 'Celular', width: '160px', render: (user) => (user.phone ? formatPhoneBR(user.phone) : '—') },
  { key: 'doc', label: 'CPF', width: '150px', render: (user) => (user.cpfCnpj ? formatDocument(user.cpfCnpj) : '—') },
  { key: 'created', label: 'Cadastro', width: '130px', align: 'right', sortKeys: ['oldest', 'recent'], render: (user) => formatDay(user.createdAt) },
];

async function load({ q, page, size, sort }) {
  if (q) {
    const results = await adminApi.searchUsers(q);
    return { results, total: results.length, pages: 1 };
  }
  const data = await adminApi.listUsers({ page, pageSize: size, sort });
  return { results: data.results || [], total: data.total, pages: data.pages || 1 };
}

// Clientes: tabela com busca, ordenacao no cabecalho e paginacao; a linha abre a pagina do cliente.
export default function UsersPage() {
  const history = useHistory();
  useSlashToSearch('ax-users-search');
  const list = useListState({ load, defaultSort: 'recent' });
  const { state, q, page, size } = list;
  const count = state.results.length;

  const meta = state.total === null ? null : q
    ? `${integer.format(count)} ${count === 1 ? 'resultado' : 'resultados'}`
    : `${integer.format(state.total)} ${state.total === 1 ? 'cliente' : 'clientes'}`;

  return (
    <div className='ax-page'>
      <PageHeader title='Clientes' meta={meta} />

      <div className='ax-toolbar'>
        <SearchInput
          id='ax-users-search'
          value={list.input}
          onChange={list.setInput}
          placeholder='Buscar por nome, e-mail, celular ou CPF'
          busy={state.status === 'loading' && Boolean(q)}
        />
        {!q && (
          <label className='ax-select'>
            <span>Por página</span>
            <select value={size} onChange={(e) => list.update({ size: Number(e.target.value), page: 1 })}>
              {[5, 10].map((option) => <option key={option} value={option}>{option}</option>)}
            </select>
          </label>
        )}
      </div>

      {state.error && <p className='ax-alert' role='alert'>{state.error}</p>}

      <DataTable
        columns={COLUMNS}
        rows={state.results}
        rowKey={(user) => user.id}
        onRowClick={(user) => history.push(`/admin/users/${user.id}`)}
        sort={q ? null : list.sort}
        onSort={q ? null : (sort) => list.update({ sort, page: 1 })}
        loading={state.status === 'loading'}
        empty={state.status === 'done' ? (
          <EmptyState
            title={q ? `Nenhum cliente encontrado para “${q}”` : 'Nenhum cliente cadastrado'}
            text={q ? 'Por número, use o CPF ou o celular completo.' : null}
            action={q ? <button type='button' className='ax-btn' onClick={() => { list.setInput(''); list.update({ q: '', page: 1 }); }}>Limpar busca</button> : null}
          />
        ) : null}
      />

      {!q && state.total > 0 && (
        <div className='ax-footer'>
          <span className='ax-muted'>
            {integer.format((page - 1) * size + 1)}–{integer.format((page - 1) * size + count)} de {integer.format(state.total)}
          </span>
          <Pagination page={page} pages={state.pages} onChange={(next) => list.update({ page: next })} disabled={state.status === 'loading'} />
        </div>
      )}
    </div>
  );
}
